import React, { useState, useEffect, useRef } from 'react';
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  updateDoc

  , collection, query, getDocs, where, addDoc

} from "firebase/firestore";
import { GoogleGenAI } from "@google/genai";
//import { generateAndUploadImage } from '../lib/text-to-image-api.js';


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAmnmaV60zqbAuij6GZcU7TuaX7_S1qsGU",
  authDomain: "musi-english.firebaseapp.com",
  projectId: "musi-english",
  storageBucket: "musi-english.firebasestorage.app",
  messagingSenderId: "299777352063",
  appId: "1:299777352063:web:c5e3de0dd12a1007307a4a"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Firebase
const db = getFirestore(app);

// Delay function to avoid rate limits
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// YouTube Player state type
declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: () => void;
  }
}

// Chart item interface
interface ChartItem {
  artist: string;
  last_week: number | string;
  peak_position: number;
  song: string;
  this_week: number;
  weeks_on_chart: number;
  yt?: string[];
  ytIndex?: number;
}

// Chart document interface
interface ChartDocument {
  date: string;
  data: ChartItem[];
}

// Lesson example interface
interface LessonExample {
  text: string;
  img: string;
  prompt?: string;
  translation?: any;
}

// Lesson content interface
interface LessonContent {
  text?: string;
  examples?: LessonExample[];
  translation?: any;
}

// Lesson interface
interface Lesson {
  level: number;
  order: number;
  content: LessonContent[];
}

const Billboard: React.FC = () => {
  // State variables
  const [chartDate, setChartDate] = useState<string>('');
  const [chart, setChart] = useState<ChartItem[]>([]);
  const [playedSongIndex, setPlayedSongIndex] = useState<number>(9);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [showDatePicker, setShowDatePicker] = useState<boolean>(false);

  // YouTube player ref
  const playerRef = useRef<any>(null);
  const playerContainerRef = useRef<HTMLDivElement>(null);
  const [isPlayerReady, setIsPlayerReady] = useState<boolean>(false);
  const hasStartedRef = useRef<boolean>(false);
  // Refs to hold latest state for callbacks attached to external APIs
  const chartRef = useRef<ChartItem[]>([]);
  const playedSongIndexRef = useRef<number>(playedSongIndex);

  // Format date as yyyy-MM-dd
  const formatDate = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Get the prior Saturday for a given date
  const getSaturday = (dateStr: string): string => {
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + ((6 + (7 - maxDate.getDay())) % 7) - 7);

    let date = new Date(dateStr);
    date.setDate(date.getDate() + ((6 + (7 - date.getDay())) % 7));

    if (date > maxDate) {
      date = new Date(maxDate.valueOf());
    } else {
      const minDate = new Date("1962-01-07");
      if (date < minDate) {
        date = new Date(minDate.valueOf());
      }
    }
    return formatDate(date);
  };

  // Get chart data from Firestore or Billboard API
  const getChart = async (date: string): Promise<ChartItem[]> => {
    try {
      // Try to get from Firestore first
      const docRef = doc(db, "charts", date);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        console.log('Chart found in Firestore for date:', date);
        const docData = docSnap.data() as ChartDocument;
        return docData.data || [];
      }
    } catch (error) {
      console.error('Error fetching from Firestore:', error);
    }

    // If not in Firestore, fetch from Billboard API
    console.log('Fetching chart from Billboard API for date:', date);
    const url = `https://raw.githubusercontent.com/mhollingshead/billboard-hot-100/main/date/${date}.json`;

    try {
      const response = await fetch(url, { method: 'GET', mode: 'cors' });

      if (response.ok) {
        const result = await response.json();
        console.log('Chart fetched from API, saving to Firestore');

        // Save to Firestore for future use
        await setDoc(doc(db, "charts", date), result);

        return result.data || [];
      } else {
        console.error('Error fetching from Billboard API:', response.statusText);
        return [];
      }
    } catch (error) {
      console.error('Error fetching chart:', error);
      return [];
    }
  };

  // Get YouTube video IDs for a song
  const getYoutubeIds = async (artist: string, song: string): Promise<string[]> => {
    const apiKey = 'AIzaSyBh-4wcA_570VyZubiQeOlGF-67_yO47YY';
    const searchQuery = encodeURIComponent(`${song} ${artist}`);
    const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&key=${apiKey}&type=video&q=${searchQuery}`;

    try {
      const response = await fetch(url, { method: 'GET', mode: 'cors' });

      if (response.ok) {
        const json = await response.json();
        const videoIds = json.items.map((item: any) => item.id.videoId).filter(Boolean);
        console.log('YouTube IDs found:', videoIds);
        return videoIds;
      } else {
        console.error('Error fetching YouTube IDs:', response.statusText);
        return [];
      }
    } catch (error) {
      console.error('Error fetching YouTube IDs:', error);
      return [];
    }
  };

  // Save YouTube IDs to Firestore
  const saveYoutubeIdsToChart = async (index: number, ytIds: string[], ytIndex: number) => {
    try {
      const docRef = doc(db, "charts", chartDate);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const chartDoc = docSnap.data() as ChartDocument;
        const updatedData = [...chartDoc.data];
        updatedData[index] = {
          ...updatedData[index],
          yt: ytIds,
          ytIndex: ytIndex
        };

        await updateDoc(docRef, { data: updatedData });
        console.log('YouTube IDs saved to Firestore');
      }
    } catch (error) {
      console.error('Error saving YouTube IDs:', error);
    }
  };

  // Play a song by index
  const playSong = async (index: number) => {
    if (!playerRef.current || !chart.length) return;

    console.log('Playing song at index:', index);
    const song = chart[index];

    // Check if YouTube IDs are already assigned
    if (!song.yt || !song.yt.length) {
      console.log('Fetching YouTube IDs for:', song.song, 'by', song.artist);
      const ytIds = await getYoutubeIds(song.artist, song.song);

      if (ytIds.length === 0) {
        console.warn('No YouTube IDs found, skipping to next song');
        playNextSong(index);
        return;
      }

      // Update local chart state
      const updatedChart = [...chart];
      updatedChart[index] = {
        ...updatedChart[index],
        yt: ytIds,
        ytIndex: 0
      };
      setChart(updatedChart);
      console.log('setChart (after adding yt ids)', { index, newLength: updatedChart.length, ytCount: ytIds.length });

      // Save to Firestore
      await saveYoutubeIdsToChart(index, ytIds, 0);

      // Play the first video
      tryPlayVideo(index, 0, ytIds);
    } else {
      // Play the video at the current ytIndex
      const ytIndex = song.ytIndex || 0;
      tryPlayVideo(index, ytIndex, song.yt);
    }
  };

  // Try to play a video, handling errors by trying the next video
  const tryPlayVideo = (songIndex: number, ytIndex: number, ytIds: string[]) => {
    console.log('tryPlayVideo called', { songIndex, ytIndex, available: ytIds.length });
    if (ytIndex >= ytIds.length) {
      console.warn('All videos failed for this song, moving to next song', { songIndex, ytIds });
      playNextSong(songIndex);
      return;
    }

    const videoId = ytIds[ytIndex];
    console.log('Loading video:', videoId, { songIndex, ytIndex });

    try {
      playerRef.current.loadVideoById({
        videoId: videoId,
        suggestedQuality: 'large'
      });

      setTimeout(() => {
        if (playerRef.current) {
          playerRef.current.playVideo();
        }
      }, 300);
    } catch (error) {
      console.error('Error loading video:', error);
      playNextSong(songIndex);
    }
  };

  // Play the next song in the countdown
  const playNextSong = (currentIndex: number) => {
    console.log('playNextSong called', { currentIndex, playerRefPresent: !!playerRef.current, isPlayerReady, chartLength: chartRef.current.length });

    let nextIndex: number;

    if (currentIndex > 0) {
      nextIndex = currentIndex - 1;
    } else {
      nextIndex = 99;
    }

    console.log('Moving to next song. Current:', currentIndex, 'Next:', nextIndex);
    setPlayedSongIndex(nextIndex);
  };

  // Handle YouTube player ready event
  const onPlayerReady = (event: any) => {
    console.log('YouTube player ready');
    playerRef.current = event.target;
    // playerRef.current.mute();
    // mark player ready; actual playback will start when chart data is present
    setIsPlayerReady(true);
  };

  // Handle YouTube player state change
  const onPlayerStateChange = (event: any) => {
    // YT.PlayerState.ENDED = 0
    console.log('onPlayerStateChange', { state: event.data, playedSongIndex: playedSongIndexRef.current, playerRefPresent: !!playerRef.current, isPlayerReady });
    if (event.data === 0) {
      console.log('Video ended, attempting to play next song from index', playedSongIndexRef.current);
      playNextSong(playedSongIndexRef.current);
    }
  };

  // Handle YouTube player error
  const onPlayerError = (event: any) => {
    console.error('YouTube player error:', event.data);
    console.log('onPlayerError context', { playedSongIndex: playedSongIndexRef.current, playerRefPresent: !!playerRef.current, chartLength: chartRef.current.length });

    // Error codes: 2 (invalid parameter), 5 (HTML5 player error), 
    // 100 (video not found), 101/150 (video not allowed to be played in embedded players)
    if ([2, 5, 100, 101, 150].includes(event.data)) {
      const idx = playedSongIndexRef.current;
      const song = chartRef.current[idx];
      console.log('onPlayerError song context', { song: song ? song.song : null, yt: song ? song.yt : undefined, ytIndex: song ? song.ytIndex : undefined });

      if (song && song.yt && song.ytIndex !== undefined) {
        const nextYtIndex = song.ytIndex + 1;

        if (nextYtIndex < song.yt.length) {
          console.log('Trying next video for this song', { idx, nextYtIndex });

          // Update local state
          const updatedChart = [...chartRef.current];
          updatedChart[idx] = {
            ...updatedChart[idx],
            ytIndex: nextYtIndex
          };
          setChart(updatedChart);
          console.log('setChart (onPlayerError, increment ytIndex)', { idx, newLength: updatedChart.length, nextYtIndex });

          // Save to Firestore
          saveYoutubeIdsToChart(idx, song.yt, nextYtIndex);

          // Try playing the next video
          tryPlayVideo(idx, nextYtIndex, song.yt);
        } else {
          console.log('All videos failed, moving to next song', { idx });
          playNextSong(idx);
        }
      } else {
        console.log('No song or no yt data on error, moving to next song', { idx });
        playNextSong(idx);
      }
    }
  };

  // Load YouTube IFrame API
  const loadYouTubeAPI = (): Promise<void> => {
    return new Promise((resolve) => {
      if (window.YT && window.YT.Player) {
        resolve();
        return;
      }

      // Create script tag
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      document.body.appendChild(tag);

      // Set callback
      window.onYouTubeIframeAPIReady = () => {
        resolve();
      };
    });
  };

  // Initialize YouTube player
  const initializePlayer = async () => {
    await loadYouTubeAPI();

    if (playerContainerRef.current && window.YT) {
      playerRef.current = new window.YT.Player(playerContainerRef.current, {
        height: '100%',
        width: '100%',
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          showinfo: 0,
          controls: 1
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError
        }
      });
    }
  };

  // Handle date change
  const handleDateChange = async (newDateStr: string) => {
    const saturday = getSaturday(newDateStr);

    if (saturday !== chartDate) {
      console.log('Changing chart date to:', saturday);
      setChartDate(saturday);
      setIsLoading(true);

      const newChart = await getChart(saturday);
      setChart(newChart);
      console.log('setChart (handleDateChange)', { newChartLength: newChart.length });
      setPlayedSongIndex(9);
      setIsLoading(false);

      // Restart playback with new chart
      if (playerRef.current && newChart.length > 0) {
        playSong(9);
      }
    }

    setShowDatePicker(false);
  };

  // Format date for display
  const formatDateForDisplay = (dateStr: string): string => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateStr).toLocaleDateString('en-US', options);
  };

  // Get min and max dates for date picker
  const getMinDate = (): string => '1962-01-07';

  const getMaxDate = (): string => {
    const today = new Date();
    const daysUntilSaturday = (6 - today.getDay() + 7) % 7;
    const nextSaturday = new Date(today);
    nextSaturday.setDate(today.getDate() + daysUntilSaturday - 7);
    return formatDate(nextSaturday);
  };

  // Get YouTube thumbnail URL
  const getYoutubeThumbnail = (): string => {
    const song = chart[playedSongIndex];
    if (song && song.yt && song.yt.length > 0 && song.ytIndex !== undefined) {
      const videoId = song.yt[song.ytIndex];
      return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
    }
    return '';
  };

  // Initialize on mount
  useEffect(() => {
    const init = async () => {
      // Get initial date (prior Saturday to today)
      const today = new Date();
      const saturday = getSaturday(formatDate(today));
      setChartDate(saturday);

      // Load chart
      const chartData = await getChart(saturday);
      setChart(chartData);
      console.log('setChart (init)', { chartDate: saturday, chartLength: chartData.length });
      setIsLoading(false);

      // Initialize YouTube player
      await initializePlayer();
    };

    init();
  }, []);

  // Start initial playback once both chart and player are ready (only once)
  useEffect(() => {
    console.log('a');
    if (!isPlayerReady) return;
    console.log('b');
    if (chart.length === 0) return;
    console.log('c');
    if (hasStartedRef.current) return;
    console.log('d');

    console.log('Player and chart ready — starting initial playback:', playedSongIndex);
    playSong(playedSongIndex);
    hasStartedRef.current = true;
  }, [isPlayerReady, chart]);

  // Keep refs in sync with latest state so external callbacks see current values
  useEffect(() => {
    chartRef.current = chart;
  }, [chart]);

  useEffect(() => {
    playedSongIndexRef.current = playedSongIndex;
  }, [playedSongIndex]);

  // Play song when playedSongIndex changes
  useEffect(() => {
    console.log('playedSongIndex effect triggered', { playedSongIndex, chartLength: chart.length, playerRefPresent: !!playerRef.current, isPlayerReady });
    if (chart.length > 0 && playerRef.current && playedSongIndex >= 0) {
      console.log('Invoking playSong for index', playedSongIndex);
      playSong(playedSongIndex);
    } else {
      console.log('Skipping playSong; preconditions not met', { chartLength: chart.length, playerRefPresent: !!playerRef.current, playedSongIndex });
    }
  }, [playedSongIndex]);

  // Current song info
  const currentSong = chart[playedSongIndex];










  async function getLyricsFromFirestore(param_songId: string) {
    const q = query(collection(db, "lyrics"), where("songId", "==", param_songId));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return [];
    }

    const doc = querySnapshot.docs[0];
    const phrases = doc.data().phrases;

    if (!phrases || !Array.isArray(phrases)) {
      return [];
    }

    return phrases.map((phrase) => phrase.text);
  }

  async function getLyrics(song_title: string, artist_name: string) {
    //const url = 'https://api.lyrics.ovh/v1/'+song_title+'/'+artist_name;
    const url = 'https://api.lyrics.ovh/v1/' + artist_name + '/' + song_title;
    const options: RequestInit = {
      method: 'GET',
      mode: 'cors'
    };
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        const result = await response.json();
        let separateLines = [...result.lyrics.split(/\r?\n|\r|\n/g)];
        let separateLines2 = [...separateLines.filter(function (el) {
          return el.trim() !== '';
        })];
        var theRemovedElement = separateLines2.shift();
        return separateLines2;
      } else {
        const err = await response.text();
        console.log('errorrr', err);
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  async function getLyricsTranslation(mylyrics: string[]) {
    const myprompt = `
      I will provide you with the lyrics of a song in English in a string array. 
      Please if you will I want you to return a single json object 
      consisting in an object array named "phrases" 
      with one object for every phrase of the provided lyrics,
      in the same order,  
      containing the translation of each phrase to these 15 languages: Spanish, Hindi, Chinese, Arabic, Portuguese, French, Russian, Indonesian, Bengali, Urdu, Turkish, Vietnamese, Japanese, Thai, Italian. 
      Each object of the "phrases" array must have these 3 properties: 
        "line_number": is a consecutive number (the first phrase is 1, the second phrase is 2, etc.), 
        "text": original text in English, 
        "translation": {
          "es": "translated text in Spanish",
          "hi": "translated text in Hindi",
          "zh": "translated text in Chinese",
          "ar": "translated text in Arabic",
          "pt": "translated text in Portuguese",
          "fr": "translated text in French",
          "ru": "translated text in Russian",
          "id": "translated text in Indonesian",
          "bn": "translated text in Bengali",
          "ur": "translated text in Urdu",
          "tr": "translated text in Turkish",
          "vi": "translated text in Vietnamese",
          "ja": "translated text in Japanese",
          "th": "translated text in Thai",
          "it": "translated text in Italian",
          }

      For example, for an input of an array with these two lines:
        Imagine there's no heaven
        It's easy if you try

      The output should be like this:
      {
        "phrases": [
          {
            "line_number": 1,
            "text": "Imagine there's no heaven",
            "translation": {
              "es": "Imagina que no hay cielo",
              "hi": "कल्पना करो कि आकाश नहीं है",
              "zh": "想象没有天堂",
              "ar": "تخيل أن لا يوجد جنة",
              "pt": "Imagine que não há céu",
              "fr": "Imagine qu'il n'y a pas de paradis",
              "ru": "Представьте, что нет рая",
              "id": "Bayangkan tidak ada surga",
              "bn": "কল্পনা করুন যে আকাশ নেই",
              "ur": "تصور کریں کہ آسمان نہیں ہے",
              "tr": "Cehennemi düşünün",
              "vi": "Hãy tưởng tượng không có thiên đường",
              "ja": "天界がないことを想像してください",
              "th": "จินตนาการว่าไม่มีสวรรค์",
              "it": "Immagina che non ci sia il paradiso"
            }
          },
          {
            "line_number": 2,
            "text": "It's easy if you try",
            "translation": {
              "es": "Es fácil si lo intentas",
              "hi": "यह आसान है अगर आप कोशिश करते हैं",
              "zh": "如果你尝试的话，这很容易",
              "ar": "إنه سهل إذا حاولت",
              "pt": "É fácil se você tentar",
              "fr": "C'est facile si vous essayez",
              "ru": "Это просто, если вы попробуете",
              "id": "Mudah jika Anda mencoba",
              "bn": "আপনি চেষ্টা করলে এটি সহজ",
              "ur": "یہ آسان ہے اگر آپ کوشش کریں",
              "tr": "Denersen kolaydır",
              "vi": "Nó dễ dàng nếu bạn cố gắng",
              "ja": "試してみれば簡単です",
              "th": "มันง่ายถ้าคุณลอง",
              "it": "È facile se ci provi"
            }
          }
        ]
      }

      The provided lyrics of the song are in this array: ${JSON.stringify(mylyrics)}
    `;
    console.log('before calling genai for translation');
    const ai = new GoogleGenAI({ apiKey: "AIzaSyAdSFKPQ6I61FiTC5klntc5X36vf2zM-D8" })
    const response = await ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: myprompt,
      config: {
        responseMimeType: "application/json",
      },
    });
    const data = JSON.parse(response.text || "{}");
    console.log('translation data:', data);
    return data;
  }

  async function getTranslation(texto: string) {
    const myprompt = `
      I have this text in English: ${texto}
      Please if you will I want its translation to these 15 languages:
      Spanish, Hindi, Chinese, Arabic, Portuguese, French, Russian, Indonesian, Bengali, Urdu, Turkish, Vietnamese, Japanese, Thai, Italian. 
      Your response shall be a single json object
      
      
      For example, for this text:
        Imagine there's no heaven

      The output should be a json object in a structure like this:
      
      {
        "es": "Imagina que no hay cielo",
        "hi": "कल्पना करो कि आकाश नहीं है",
        "zh": "想象没有天堂",
        "ar": "تخيل أن لا يوجد جنة",
        "pt": "Imagine que não há céu",
        "fr": "Imagine qu'il n'y a pas de paradis",
        "ru": "Представьте, что нет рая",
        "id": "Bayangkan tidak ada surga",
        "bn": "কল্পনা করুন যে আকাশ নেই",
        "ur": "تصور کریں کہ آسمان نہیں ہے",
        "tr": "Cehennemi düşünün",
        "vi": "Hãy tưởng tượng không có thiên đường",
        "ja": "天界がないことを想像してください",
        "th": "จินตนาการว่าไม่มีสวรรค์",
        "it": "Immagina che non ci sia il paradiso"
      }
    `;
    console.log('before calling genai for translation of:', texto);
    const ai = new GoogleGenAI({ apiKey: "AIzaSyAdSFKPQ6I61FiTC5klntc5X36vf2zM-D8" });
    const response = await ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: myprompt,
      config: {
        responseMimeType: "application/json",
      },
    });

    const data = JSON.parse(response.text || "{}");
    console.log('data:', data);
    return data;
  }

  async function getYt_videoIdsFromYoutube(sng: string, perf: string) {
    var result: string[] = [];
    ////console.log('xyz','https://www.googleapis.com/youtube/v3/search?part=snippet&key=AIzaSyBh-4wcA_570VyZubiQeOlGF-67_yO47YY&type=video&q='+sng+' '+perf);
    await fetch('https://www.googleapis.com/youtube/v3/search?part=snippet&key=AIzaSyBh-4wcA_570VyZubiQeOlGF-67_yO47YY&type=video&q=' + sng + ' ' + perf, {
      method: 'GET',
      mode: 'cors'
    })
      .then(function (response) {
        if (!response.ok) {
          //throw Error(response.statusText);
          return [];
        }
        // Read the response as json.
        return response.json();
      })
      .then(function (responseAsJson) {
        //console.log('todos los items no solo el primero que fue el que usamos',responseAsJson.items);
        /*that.yt_videoId = responseAsJson.items[ocurrencia].id.videoId;*/
        // that.siguienteVideo=0;
        // that.validVideo=0;
        /*let myEvent = new CustomEvent('my-event', {
          detail: { message: responseAsJson.items[ocurrencia].id.videoId }
        });
        that.dispatchEvent(myEvent);*/
        // that.shadowRoot.querySelector('#snack').show();
        /*that.yt_title = responseAsJson.items[ocurrencia].snippet.title;
        that.yt_thumbnails_default_url = responseAsJson.items[ocurrencia].snippet.thumbnails.default.url;
        that.yt_thumbnails_default_width = responseAsJson.items[ocurrencia].snippet.thumbnails.default.width;
        that.yt_thumbnails_default_height = responseAsJson.items[ocurrencia].snippet.thumbnails.default.height;*/

        /*
        const db = getDatabase();
        set(ref(db, 'songs/' + that.SongID), {
          Performer: perf,
          Song: sng,
          yt_videoId: that.yt_videoId,
          yt_title: that.yt_title,
          yt_thumbnails_default_url: that.yt_thumbnails_default_url,
          yt_thumbnails_default_width: that.yt_thumbnails_default_width,
          yt_thumbnails_default_height: that.yt_thumbnails_default_height
        });*/
        /*console.log('set',that.SongID,' ',perf,' ',sng,' ',that.yt_videoId,' ',that.yt_title);*/
        for (let ixx = 0; ixx < responseAsJson.items.length; ixx++) {
          result.push(responseAsJson.items[ixx].id.videoId);
        }
      })
      .catch(function (error) {
        console.log('Looks like there was a problem: \n', error);
        return '';
      });
    return result;
  }

  /*async function _getCertainPhrases() {
    let __verbosPasado: string[] = [];
    let __verbosParticipio: string[] = [];
    let __verbosGerundio: string[] = [];
    let _verbosPasado: { verb: string; phrase: string }[] = [];
    let _verbosParticipio: { verb: string; phrase: string }[] = [];
    let _verbosGerundio: { verb: string; phrase: string }[] = [];
    let todobien = true;
    let temporalObject;
    for (let i = 0; (i < taggedLyrics.length); i++) {
      for (let j = 0; (j < taggedLyrics[i].tags.length); j++) {
        if (taggedLyrics[i].tags[j].tag === "VBD") {
          if (__verbosPasado.indexOf(taggedLyrics[i].tags[j].word.toLowerCase())<0){
            __verbosPasado.push(taggedLyrics[i].tags[j].word.toLowerCase());
            temporalObject = {
              verb : taggedLyrics[i].tags[j].word.toLowerCase(),
              phrase : taggedLyrics[i].phrase.toLowerCase() 
            };
            _verbosPasado.push(temporalObject);
          }
        }
        if (taggedLyrics[i].tags[j].tag === "VBN") {
          if (__verbosParticipio.indexOf(taggedLyrics[i].tags[j].word.toLowerCase())<0){
            __verbosParticipio.push(taggedLyrics[i].tags[j].word.toLowerCase());
            temporalObject = {
              verb : taggedLyrics[i].tags[j].word.toLowerCase(),
              phrase : taggedLyrics[i].phrase.toLowerCase() 
            };
            _verbosParticipio.push(temporalObject);
          }
        }
        if (taggedLyrics[i].tags[j].tag === "VBG") {
          if (__verbosGerundio.indexOf(taggedLyrics[i].tags[j].word.toLowerCase())<0){
            __verbosGerundio.push(taggedLyrics[i].tags[j].word.toLowerCase());
            temporalObject = {
              verb : taggedLyrics[i].tags[j].word.toLowerCase(),
              phrase : taggedLyrics[i].phrase.toLowerCase() 
            };
            _verbosGerundio.push(temporalObject);
          }
        }
      }
    }
    verbosPasado = _verbosPasado ? [..._verbosPasado] : [];
    verbosParticipio = _verbosParticipio ? [..._verbosParticipio] : [];
    verbosGerundio = _verbosGerundio ? [..._verbosGerundio] : [];
    return todobien;
  }*/

  // Read the "prompt" string from a document in the "levels" collection by id
  async function getLevelPrompt(levelId: string): Promise<string | null> {
    try {
      const docRef = doc(db, "levels", levelId);
      const snap = await getDoc(docRef);
      if (!snap.exists()) return null;
      const data = snap.data();
      if (!data || typeof data.prompt !== "string") return null;
      return data.prompt;
    } catch (err) {
      console.error('getLevelPrompt error:', err);
      return null;
    }
  }

  async function getTwistedPhrases(exampleText: string) {
    const myprompt = `
    I will provide you with an example text which is a very short phrase, expression or even a word in English. (It will be labeled *** Provided example text:)

    I want you to return 3 mistakenly written string elements based on the provided example text. They can be the same provided example text but misspelled or with evident big grammatical errors or evident errors of any kind.

    The output must be a single json object with an object array named "twisted", 
    each object containing one of the 3 mistakenly written string elements based on the provided example text.
    For example for an input example text of "the love" this could be the output:
      {
        "twisted": [
          "thee love",
          "the luv",
          "the loove"
        ]
      }

      *** Provided example text:

      ${exampleText}

    `;

    console.log('before calling genai for getting twisted examples');
    const ai = new GoogleGenAI({ apiKey: "AIzaSyAdSFKPQ6I61FiTC5klntc5X36vf2zM-D8" });
    const response = await ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: myprompt,
      config: {
        responseMimeType: "application/json",
      },
    });
    const data = JSON.parse(response.text || "{}");
    console.log('sample data:', data);
    if (!data || !data.twisted) {
      console.log('Error: no twisted field in data');
      return null;
    }
    return data.twisted;
  }

  async function getExamples(mylyrics: string[], lesson: number) {

    const currentLevel = "" + lesson;
    const mylesson = await getLevelPrompt(currentLevel);
    console.log('level:', lesson, 'prompt:', mylesson);

    const myprompt = `
    I want to teach English as a foreign language using music lyrics. I want you to return 6 different examples from a provided lyrics string array, illustrating a provided topic. 

    I will provide you with a string array with the lyrics of a song in English. (that provided lyrics string array will be labeled *** Provided lyrics:)

    I will also provide you with a lesson (that provided lesson is a topic of the English language that I want the examples to illustrate to the students, and further explanations on the type of examples I want). (That provided lesson will be labeled *** Provided lesson:)

    I want you to return me a single json object with an object array with 6 different objects named "examples", 
    each object containing two fields: "text" and "index". 
    The "text" field is an example that can be a very short phrase, expression or even a word extracted from or based on the provided lyrics, that illustrate the provided lesson. 
    The "index" field is the index of the provided lyrics array, from which the example was extracted or based.

    The examples you provide must be different from each other and illustrate the provided lesson about the English language.

    Sample output:
      {
        "examples": [
          {
            text: "the love",
            index: 18
          },
          {
            text: "the games",
            index: 23
          },
          {
            text: "the blue car",
            index: 42
          },
          {
            text: "the houses",
            index: 55
          },
          {
            text: "the fate",
            index: 57
          },
          {
            text: "the happy boys",
            index: 60
          }
        ]
      }

      *** Provided lesson:

      ${mylesson}

      *** Provided lyrics:

      ${JSON.stringify(mylyrics)}

    `;
    console.log('before calling genai for getting examples');
    const ai = new GoogleGenAI({ apiKey: "AIzaSyAdSFKPQ6I61FiTC5klntc5X36vf2zM-D8" })
    const response = await ai.models.generateContent({
      model: "gemini-2.5-flash",
      contents: myprompt,
      config: {
        responseMimeType: "application/json",
      },
    });
    const data = JSON.parse(response.text || "{}");
    console.log('sample data:', data);
    if (!data || !data.examples) {
      console.log('Error: no examples field in data');
      return null;
    }
    return data.examples;
  }

  /*async function getImage(queryText: string): Promise<string> {
        fetch("https://api.freepik.com/v1/ai/mystic", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "x-freepik-api-key": "FPSX6fc33387daf61a72596a3b858260dfa9"
          },
          body: JSON.stringify({
          "prompt": queryText,
          "aspect_ratio": "classic_4_3"
        })
        })
        .then(response => response.json())
        .then(data => console.log(data));
    
    
        if (!data || data.status !== "OK") {
          console.log('Image generation error:', data ? data.statusText : 'No data');
          return '';
        }
        return data.direct_link;
    return '';
  }*/
  /*
    async function getImageOld(queryText: string): Promise<string> {
      const response = await fetch('https://api.imgbun.com/png?key=6c8e2082eb0f030007f7bf933a55da20&text=' + encodeURIComponent(queryText), {
        method: 'GET',
        mode: 'cors'
      });
      if (!response.ok) {
        console.log('Image generation request failed with status:', response.statusText);
        return '';
      }
      const data = await response.json();
      if (!data || data.status !== "OK") {
        console.log('Image generation error:', data ? data.statusText : 'No data');
        return '';
      }
      return data.direct_link;
      //const imageResponse = await fetch('https://api.unsplash.com/photos/random?query='+encodeURIComponent(examples[i].text)+'&client_id=YOUR_UNSPLASH_ACCESS_KEY', {
      //  method: 'GET',
      //  mode: 'cors'
      //});
      //if (imageResponse.ok) {
      //  const imageData = await imageResponse.json();
      //  obj.image = imageData.urls.regular;
      //} else {
      //  obj.image = "";
      //}
    }*/

  /*
  async function processImg666(promptx: string): Promise<void> {
    // Make the request
    const response = await fetch("https://cors-anywhere.herokuapp.com/https://subnp.com/api/free/generate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        prompt: "The car",
        model: "turbo"
      })
    });

    // Create event source for streaming updates
    if (!response.body) {
      console.error('Response body is null');
      return;
    }

    const reader = response.body
      .pipeThrough(new TextDecoderStream())
      .pipeThrough(new TransformStream({
        transform(chunk, controller) {
          // Parse SSE data
          const lines = chunk.split('\n');
          const messages = lines
            .filter(line => line.startsWith('data: '))
            .map(line => JSON.parse(line.slice(6)));

          messages.forEach(data => {
            switch (data.status) {
              case 'processing':
                console.log('Progress:', data.message);
                break;
              case 'complete':
                console.log('Image URL:', data.imageUrl);
                break;
              case 'error':
                console.error('Error:', data.message);
                break;
            }
          });
        }
      }));

    // Start reading the stream
    const readerInstance = reader.getReader();
    try {
      while (true) {
        const { done, value } = await readerInstance.read();
        if (done) break;
      }
    } finally {
      readerInstance.releaseLock();
    }
  }*/
  /*
    async function processImg2(promptx: string) {
      fetch("https://api.freepik.com/v1/ai/mystic", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "x-freepik-api-key": "FPSX6fc33387daf61a72596a3b858260dfa9"
        },
        body: JSON.stringify({
        "prompt": promptx,
        "aspect_ratio": "widescreen_16_9"
      })
      })
      .then(response => response.json())
      .then(data => console.log(data));
    }
  

  */
  async function processSong(song: string, artist: string) {
    let songId = '';
    let lyricsCompletado = false;
    let fullyCompletado = false;
    let yt: string[] = [];
    let startInLesson = 1;
    let translation = null;
    let position = 1;
    let ytIndex = 0;
    let creator = "juanhenaob@gmail.com";
    console.log('processing song:', song, 'by artist:', artist);
    const q = query(collection(db, "songs"), where("name", "==", song), where("artist", "==", artist));
    const querySnapshot = await getDocs(q);
    querySnapshot.forEach((doc) => {
      songId = doc.id;
      yt = doc.data().yt ? [...doc.data().yt] : [];
      lyricsCompletado = doc.data().lyricsCompletado;
      fullyCompletado = doc.data().fullyCompletado;
      startInLesson = doc.data().startInLesson;
      translation = doc.data().translation;
      position = doc.data().position;
      ytIndex = doc.data().ytIndex;
      creator = doc.data().creator;
      console.log('songs document read', song, 'songId', songId, 'yt', yt, 'lyricsCompletado', lyricsCompletado, 'fullyCompletado', fullyCompletado, 'startInLesson', startInLesson);
    });
    if (fullyCompletado) {
      console.log('the song was already added', song, 'by artist:', artist);
      return true;
    }
    if (songId === '') {
      try {
        let newSong: any = {};
        newSong.name = song;
        newSong.artist = artist;
        newSong.creator = creator;
        newSong.ytIndex = ytIndex;
        newSong.lyricsCompletado = lyricsCompletado;
        newSong.fullyCompletado = fullyCompletado;
        newSong.startInLesson = startInLesson;
        newSong.position = position;
        let docRef = await addDoc(collection(db, "songs"), newSong);
        songId = docRef.id;
        console.log('document added to songs', newSong, 'songId', songId);
      } catch (error) {
        console.error(error);
        alert('sorry, could not save to songs');
        return false;
      }
    }
    console.log('songId to process lyrics:', songId);
    if (!translation) {
      console.log('translating song title:', song);
      const translationResult = await getTranslation(`${song}`);
      console.log('translation result from genai:', translationResult);
      try {
        const songRef = doc(db, "songs", songId);
        await updateDoc(songRef, {
          translation: translationResult
        });
        translation = translationResult;
      } catch (error) {
        console.error(error);
        alert('sorry, could not translate song title');
        return false;
      }
      console.log('translation of song title saved to firestore:', translation);
    }
    console.log('getting lyrics of: ', song, 'by artist:', artist);

    let mylyrics = null;
    if (lyricsCompletado) {
      mylyrics = await getLyricsFromFirestore(songId);
      console.log('got lyrics from firestore:', mylyrics);
    } else {
      mylyrics = await getLyrics(song, artist);
      console.log('got lyrics from lyrics.ovh:', mylyrics);
    }
    if (!mylyrics) {
      console.log('Lo siento. No se encontró la letra de ' + song + ' by ' + artist);
      return false;
    }
    if (!lyricsCompletado) {
      try {
        let obj: any = {};
        let docRef;
        obj.name = song;
        obj.artist = artist;
        obj.songId = songId;
        obj.translation = translation;
        const AIAnswer = await getLyricsTranslation(mylyrics);
        if (!AIAnswer) {
          console.log('12. Translation error. Stopping processSong');
          return false;
        }
        console.log('19. paso 666: got lyrics translation', AIAnswer);
        obj.phrases = AIAnswer.phrases;
        console.log('20. paso 664 adding lyrics to firestore', obj);
        docRef = await addDoc(collection(db, "lyrics"), obj);
        console.log('20. paso 6 a: lyrics added to firestore', docRef);
      } catch (error) {
        console.error(error);
        alert('sorry, could not fully save lyrics');
        return false;
      }
      if (songId !== '') {
        try {
          const songRef = doc(db, "songs", songId);
          await updateDoc(songRef, {
            lyricsCompletado: true
          });
          lyricsCompletado = true;
        } catch (error) {
          console.error(error);
          alert('sorry, could not update songs with lyricsCompletado');
          return false;
        }
        console.log('21. paso 6 b: songs updated with lyricsCompletado');
      }
    }

    if (yt.length <= 0) {
      console.log('getting youtube video ids for song:', song, 'by artist:', artist);
      yt = await getYt_videoIdsFromYoutube(song, artist);
      if (yt.length <= 0) {
        console.log('sorry, no video found on youtube');
        return false;
      }
      console.log('got yt', yt);
      try {
        const songRef = doc(db, "songs", songId);
        await updateDoc(songRef, {
          yt: yt
        });
        console.log('songs updated with yt', yt);
      } catch (error) {
        console.error(error);
        alert('sorry, could not update songs with yt');
        return false;
      }
    } else {
      console.log('yt ya lo teniamos', yt);
    }

    for (let lesson = startInLesson; lesson < 4; lesson++) {

      const examples = await getExamples(mylyrics, lesson);
      if (!examples) {
        console.log('Stopping process Song for Error getting examples for level ', lesson);
        return false;
      }
      console.log('got examples', examples);

      // for each example, 
      // get "translation", "twisted", and "image", 
      // and save to Firestore
      for (let i = 0; i < examples.length; i++) {
        try {
          let obj: any = {};
          obj.songId = songId;
          obj.level = lesson;
          obj.text = examples[i].text;
          obj.index = examples[i].index;
          const translationResult = await getTranslation(examples[i].text);
          obj.translation = translationResult;
          await delay(80000); // Delay to avoid rate limits
          const twistedPhrases = await getTwistedPhrases(examples[i].text);
          obj.twisted = twistedPhrases;
          await delay(80000); // Delay to avoid rate limits
          //const imageResponse = await getImage(examples[i].text);
          const imageResponse = await fetchUnsplash(examples[i].text, 'default')
          const imageResponseParsed = imageResponse;
          if (!imageResponse) {
            console.log('Error getting image for level ', lesson);
            obj.imageUrl = '';
            obj.imagePermanentLink = '';
            obj.imageFull = '';
          } else {
            obj.imageUrl = imageResponseParsed.image.url;
            obj.imagePermanentLink = imageResponseParsed.image.permanent_link;
            obj.imageFull = imageResponseParsed.image.full;
          }
          console.log('before delay');
          await delay(120000); // Delay to avoid rate limits
          console.log('after delay');
          console.log('before adding to firestore');
          const docRef = await addDoc(collection(db, "examples"), obj);
          console.log('examples document added for level ', lesson, 'docRef:', docRef, 'obj:', obj);
        } catch (error) {
          console.error(error);
          alert('sorry, could not save examples for level ' + lesson);
          return false;
        }

        // Update the song document to set startInLesson to the next lesson
        try {
          const songRef = doc(db, "songs", songId);
          await updateDoc(songRef, {
            startInLesson: lesson + 1
          });
          console.log('songs updated with startInLesson', lesson + 1);
        } catch (error) {
          console.error(error);
        }


      }
      console.log('after adding text, index, translation, twisted, and image to examples and saving to firestore:', examples);

    }

    try {
      const songRef = doc(db, "songs", songId);
      await updateDoc(songRef, {
        fullyCompletado: true
      });
      console.log('songs updated with fullyCompletado true');
    } catch (error) {
      console.error(error);
      alert('sorry, could not update songs with fullyCompletado');
      return false;
    }

    console.log('finished processing song:', song, 'by artist:', artist);


    return true;
  }

  const fetchUnsplash = async (prompt: string, imageSource: 'pixabay' | 'default' = 'pixabay') => {
    try {
      const baseUrl = 'https://musienglish-api.onrender.com/api/image-search'
      const url = imageSource === 'pixabay' ? `${baseUrl}/pixabay` : baseUrl

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          prompt: prompt
        })
      })
      if (!response.ok) {
        return null;
      }
      const responseJson = await response.json();
      if (!responseJson.success) {
        return null;
      }
      return responseJson;
    } catch (error) {
      return null;
    }
  }

  async function tempFetchUnsplash() {
    const imageResponse = await fetchUnsplash('the morning light', 'default')
    if (!imageResponse) {
      console.log('Stopping process Song for Error getting image for level ');
      return false;
    }
    const imageResponseParsed = imageResponse;
    let obj: any = {};
    obj.imageUrl = imageResponseParsed.image.url;
    obj.imagePermanentLink = imageResponseParsed.image.permanent_link;
    obj.imageFull = imageResponseParsed.image.full;
    console.log('imageResponseParsed', imageResponseParsed);
    console.log('obj.imageUrl', obj.imageUrl);
    console.log('obj', obj);
    return obj;
  }











  return (
    <div style={styles.container}>
      <div style={styles.content}>

        {/*

        <button onClick={() => { lessonToFirestore(); }}>
          add lessons to firestore
        </button>



        <button onClick={() => { processSong("The Fate Of Ophelia", "Taylor Swift"); }}>
          process song
        </button>
        <div id="images"></div>

        <button onClick={tempFetchUnsplash}>
          Fetch Unsplash
        </button> */}


        {/* Header */}
        <div style={styles.header}>
          <h1 style={styles.title}>Billboard Hot 100</h1>
          <div style={styles.dateSection}>
            <div style={styles.dateDisplay}>
              {chartDate ? formatDateForDisplay(chartDate) : 'Loading...'}
            </div>
            <button
              style={styles.changeDateButton}
              onClick={() => setShowDatePicker(!showDatePicker)}
            >
              Change Date
            </button>
          </div>

          {/* Date Picker */}
          {showDatePicker && (
            <div style={styles.datePickerContainer}>
              <input
                type="date"
                value={chartDate}
                min={getMinDate()}
                max={getMaxDate()}
                onChange={(e) => handleDateChange(e.target.value)}
                style={styles.datePicker}
              />
            </div>
          )}
        </div>

        {/* YouTube Player */}
        <div style={styles.playerContainer}>
          <div
            ref={playerContainerRef}
            style={styles.player}
          />
        </div>

        {/* Current Song Info */}
        <div style={styles.songInfo}>
          {isLoading ? (
            <div style={styles.loadingText}>Loading chart...</div>
          ) : currentSong ? (
            <div style={{
              backgroundColor: 'rgba(0,0,0,0.4)',
              backdropFilter: 'blur(10px)',
              padding: '8px 12px',
              borderRadius: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(8px, 2vw, 12px)',
              flexWrap: 'wrap'
            }}>
              {/* YouTube Thumbnail */}
              {getYoutubeThumbnail() && (
                <img
                  src={getYoutubeThumbnail()}
                  alt={currentSong.song}
                  style={{
                    width: '60px',
                    height: '45px',
                    borderRadius: '6px',
                    objectFit: 'cover'
                  }}
                />
              )}

              <div style={{ flex: 1, minWidth: '150px' }}>
                <div style={{
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  marginBottom: '4px'
                }}>
                  #{currentSong.this_week} - {currentSong.song}
                </div>

                <div style={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: '0.85rem'
                }}>
                  {currentSong.artist}
                </div>

                <div style={{
                  color: 'rgba(255,255,255,0.6)',
                  fontSize: '0.8rem',
                  marginTop: '4px'
                }}>
                  Peak: #{currentSong.peak_position} • Weeks on chart: {currentSong.weeks_on_chart}
                </div>
              </div>
            </div>
          ) : (
            <div style={styles.loadingText}>No song data available</div>
          )}
        </div>
      </div>
    </div>
  );
};

// Styles
const styles: { [key: string]: React.CSSProperties } = {
  container: {
    minHeight: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    padding: 'clamp(3rem, 12vh, 12rem) clamp(0.5rem, 1vw, 1rem)',
    boxSizing: 'border-box',
    overflow: 'auto'
  },
  content: {
    maxWidth: '56rem',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(1rem, 1.5vh, 1.5rem)'
  },
  header: {
    background: 'rgba(255, 255, 255, 0.10)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '12px',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
    padding: 'clamp(1rem, 1.5vh, 1.5rem)',
    textAlign: 'center'
  },
  title: {
    fontSize: 'clamp(1.25rem, 4vw, 1.875rem)',
    fontWeight: 700,
    color: '#150ae8',
    marginBottom: '0.5rem',
    textShadow: '2px 2px 4px rgba(15, 233, 248, 0.3)'
  },
  dateSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    flexWrap: 'wrap'
  },
  dateDisplay: {
    fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
    fontWeight: 600,
    color: '#150ae8',
    textShadow: '1px 1px 2px rgba(15, 233, 248, 0.3)'
  },
  changeDateButton: {
    padding: '0.5rem 1rem',
    background: 'rgba(255, 255, 255, 0.2)',
    backdropFilter: 'blur(5px)',
    border: 'none',
    borderRadius: '9999px',
    color: '#150ae8',
    fontSize: '0.875rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s',
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
  },
  datePickerContainer: {
    marginTop: '1rem',
    display: 'flex',
    justifyContent: 'center'
  },
  datePicker: {
    padding: '0.5rem 1rem',
    background: 'rgba(255, 255, 255, 0.9)',
    border: '1px solid rgba(255, 255, 255, 0.3)',
    borderRadius: '8px',
    fontSize: '1rem'
  },
  playerContainer: {
    background: 'rgba(255, 255, 255, 0.10)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
    position: 'relative',
    paddingBottom: 'clamp(35vh, 56.25%, 35vh)',
    height: 0
  },
  player: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  songInfo: {
    background: 'rgba(255, 255, 255, 0.10)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderRadius: '12px',
    border: '1px solid rgba(255, 255, 255, 0.18)',
    boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
    padding: 'clamp(1rem, 1.5vh, 1.5rem)',
    minHeight: 'clamp(90px, 12vh, 120px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  songInfoContent: {
    display: 'flex',
    gap: '1.5rem',
    alignItems: 'center',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  songDetails: {
    flex: 1,
    minWidth: '250px'
  },
  songPosition: {
    fontSize: 'clamp(1.25rem, 3vh, 2rem)',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: '0.25rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  songTitle: {
    fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
    fontWeight: 700,
    color: '#ffffff',
    marginBottom: '0.25rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  songArtist: {
    fontSize: 'clamp(0.9rem, 2vw, 1.25rem)',
    color: '#ffffff',
    opacity: 0.9,
    marginBottom: '0.75rem',
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
  },
  songStats: {
    display: 'flex',
    gap: '1.5rem',
    flexWrap: 'wrap'
  },
  statItem: {
    fontSize: 'clamp(0.75rem, 1.5vh, 0.875rem)',
    color: '#ffffff',
    opacity: 0.8,
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
  },
  thumbnailContainer: {
    flexShrink: 0
  },
  thumbnail: {
    width: 'clamp(80px, 12vw, 120px)',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
  },
  loadingText: {
    color: '#ffffff',
    fontSize: '1rem',
    textShadow: '1px 1px 2px rgba(0,0,0,0.3)'
  }
};

export default Billboard;
